__webpack_require__.p = "https://beta.cdn.workspaces-web.com/";